module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-5"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-5"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-5"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-3"
  }), _vm._v(" "), _c('p', {
    staticClass: "x-1-Chapter-number"
  }, [_vm._v("Chapter One")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-5"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "x-2-chapter-title"
  }, [_vm._v("“[They] Had Set Their Hearts Upon the Southern Cross”")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-3"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("In the long experience of mankind, it may be safely said that whenever man espoused a cause, he created a flag—a banner—to celebrate it or to use defending it. When eleven slave states seceded from the Union and formed a new confederacy")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("in late 1860 and in 1861, one of the great discussions among people of each seceded state, and of the Confederacy as a whole, was what flag they would fly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-13"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("During the months leading up to the secession")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("of South Carolina")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("from the Union, a profusion of flags appeared throughout that state. Most called to mind the state’s Revolutionary War experience, incorporating the palmetto tree")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("and crescent moon")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("on a blue or white field. When the South Carolina Secession Convention")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("met in the First Baptist Church")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("in Columbia")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("to consider an ordinance of secession")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("on December 17, 1860, a flag was observed by a reporter from the")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Charleston")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Daily Courier")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(":")])]), _vm._v(" "), _c('p', {
    staticClass: "x-e-Extract-6"
  }, [_vm._v("A beautiful silk flag, of blue ground with gilt fringe presented by a lady of Charleston, was suspended over the State House, bearing on one side the words “South Carolina Convention 1860.” On the reverse a Palmetto, and at the trunk an open Bible, with the following: “God is our refuge and our strength, a very present help in time of trouble; therefore will we not fear; though the earth be removed, and though the mountains be carried into the sea. The Lord of Hosts is with us, the God of Jacob is our refuge.”"), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n101",
      "id": "n101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Smallpox broke out in Columbia")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", causing the secession")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("convention")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("to move to Charleston")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". There, in Institute Hall")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", and then in the smaller St. Andrew’s Hall")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("on Meeting Street, the delegates reconvened. Patriotic emblems hung from poles and lines all over the city. A liberty pole stood at the corner of Hayne and Meeting Streets. The Pavilion Hotel")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("at the corner of Meeting and Hasell Streets displayed a banner depicting Hiram Powers’ statue of John C. Calhoun")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("holding a shattered tablet with the inscribed words: “Truth, Justice, and the Constitution")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(".” Calhoun appeared on the banner to be looking down from the clouds; below his figure were the words: “Behold its Fate.”")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n102",
      "id": "n102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
    staticClass: "frame-2a"
  }, [_c('img', {
    staticClass: "frame-9",
    attrs: {
      "alt": "7%20Charleston%20Convention_upsized.tif",
      "src": "Images/7%20Charleston%20Conventio_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame-10"
  }, [_c('p', {
    staticClass: "caption-8",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The Charleston Secession Convention, December 20, 1860, a woodcut. "), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("(Courtesy of the Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Another banner was spotted by a Charleston")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("newspaper reporter who noted: “Over the president’s chair was suspended a scarlet banner, with a blue quarter, emblazoned with the ancient crescent and the Lone Star")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(".” A third banner hung on a line from the officer’s quarters of the Lower Guard House")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("at the corner of Meeting and Broad Streets across the intersection to city hall")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". It also featured an illustration of Powers’ statue of Calhoun")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", but portrayed South Carolina")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("as the cornerstone of an edifice of Southern states, with the words: “")]), _c('span', {
    staticClass: "char-style-override-11"
  }, [_vm._v("built from the ruins")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(".” Later, on December 20, that banner was taken down and hung above the dais in Institute Hall")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(".")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n103",
      "id": "n103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Beneath that flag, the delegates voted to rescind South Carolina")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("’s ratification of the Constitution")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("and dissolve the state’s union with the United States on December 20, 1860. The voting took only eight minutes. David F. Jamison")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", president of the secession")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("convention")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", tallied the votes and then, at 1:15 p.m., said in a loud voice: “I proclaim the State of South Carolina an Independent Commonwealth.” Wild cheering echoed through the hall and could be heard up and down Meeting Street.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n104",
      "id": "n104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("In the larger Institute Hall")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("the delegates signed the Ordinance of Secession")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". Institute Hall, the grand edifice of the South Carolina")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Institute, was built in the mid-1850s for operas and concerts, as well as the annual fairs of the institute itself. Elaborately decorated with emblems of the palmetto tree")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", classical figures, rice, cotton, and symbols of commerce by none other than artist Vivio Garibaldi")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", the nephew of Italian hero Giuseppe Garibaldi")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", Institute Hall was a")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("magnificent backdrop to South Carolina’s most historic moment. The document having been signed in front of the huge assemblage, William Edward Martin")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", clerk of the South Carolina")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Senate for over twenty years, walked onto Meeting Street and")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("read aloud South Carolina’s Ordinance of Secession. He concluded")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("by calling for three cheers “for the separate Commonwealth of South Carolina.” The new “commonwealth” needed a flag.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n105",
      "id": "n105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("One flag that was advocated by many as a banner for the new commonwealth was reported by the press as appearing in Charleston")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("after the secession")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("convention")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". The flag appears to have been the South Carolina")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("“Lone Star")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("” flag. It consisted of a red field bearing a single, white, five-pointed star. There were others. As early as December 3, 1860,")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Charleston Mercury")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("published a number of suggestions for a potential flag. “Let her standard be,” it wrote, “the simple scarlet, with fifteen stars. True, it will be a star spangled banner—but with nothing of the barber pole about it.”")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n106",
      "id": "n106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Even earlier, on November 10, 1860, the")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Mercury")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("suggested “a plain scarlet field, powdered with fifteen stars, white or yellow, according to fancy.” Thought to be presented by the same “enthusiastic friend of the")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Mercury")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(",” another flag had been suggested on November 13: “A scarlet field, powdered with fifteen white stars, without stripes or eagles, intended to typify the future Confederacy")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("of fifteen sovereign southern slave states.” South Carolinians firmly believed that every one of the fifteen slave states in the Union would secede and join Carolina.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n107",
      "id": "n107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("One of the very popular flags was sewed together by a group of ladies in Charleston")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("just before the vote on the Ordinance of Secession")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". The flag—actually a large swallowtail pennant—was eight feet long and six feet wide. The field was “turkey [blood] red,” with “an immense white star in the center and a white crescent in the left-hand corner.” On the morning after the secession vote, the giant flag was hoisted over the Customs House")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("at the end of Broad Street on East Bay Street.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n108",
      "id": "n108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Out of all the variations for a flag proposed before and after the secession")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("convention")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", the Latin cross")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("emblem emerged as the one of choice, particularly in South Carolina")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". The “Washington Artillery")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("” of the Charleston")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("militia (not to be confused with the famed Washington Artillery of New Orleans")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("or with Capt. James F. Hart")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("’s South Carolina Battery")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", which was also known as the Washington Artillery) assembled on the parade ground of the Citadel")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("in Charleston after the secession convention carrying a flag that was described by the")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Charleston Mercury")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(":")])]), _vm._v(" "), _c('p', {
    staticClass: "x-e-Extract-6"
  }, [_vm._v("The flag is a red field, expressive of defiance, traversed by the blue cross of Carolina, with the lone star at the intersection. The inner and upper quarter of the field bears the word “"), _c('span', {
    staticClass: "char-style-override-12"
  }, [_vm._v("ready")]), _vm._v("” surmounted by the palmetto."), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n109",
      "id": "n109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("The Washington Artillery")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("was not alone. The Charleston")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Zouave Cadets")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("had a similar flag. Reported the")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Charleston Daily Courier")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("on December 22, 1860:")])]), _vm._v(" "), _c('p', {
    staticClass: "x-e-Extract-6"
  }, [_vm._v("When the first gun, “Old Secession,” announced the secession of the State, they flung to the breeze the beautiful flag which now floats over their gymnasium. It is a red field, quartered with a blue cross, on which is a lone star (others will be added as [states] come into the Southern Constellation). On the upper quarter is the Palmetto, on the lower a savage looking tiger head.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("The Washington Artillery")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("and the Charleston")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Zouave Cadets")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("were soon sent to occupy Castle Pinckney")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", an impressive, stone bastion fort that defended the channel of Charleston Harbor")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("closest to the city.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n110",
      "id": "n110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "frame-2a"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "8%20Sovereignty%20Flag_upsized.tif",
      "src": "Images/8%20Sovereignty%20Flag_ups_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame-10"
  }, [_c('p', {
    staticClass: "caption-8",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("The sovereignty flag, a woodcut.")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("(Courtesy of the Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "caption-8"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("On Christmas Day 1860 the “Charleston Correspondent” for the "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("New York Herald")]), _vm._v(" reported the earliest account of what came to be known as the “sovereignty flag.” Designed by an unknown Charleston woman, it was a rectangular flag with a cruciform—or “Latin cross”—design consisting of blue horizontal arms and vertical arms with four five-pointed stars across both horizontal arms and three across both vertical arms, with one large five-pointed star in the center of the cross. In the upper-left quadrant of the flag were the palmetto and crescent emblems of South Carolina. A woodcut of the flag appeared in the "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Herald")]), _vm._v(". That was followed by another depiction of the flag in the "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Illustrated London")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("News")]), _vm._v(" on February 2, 1861. Wrote the "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Illustrated London News")]), _vm._v(", “This is, we believe, the first flag which has been put forward by either of the seceding States.” The sovereignty flag was very popular in South Carolina. So popular was it that it became known there, and in other areas of the southland, as “the Southern Cross.” Although not formally adopted by South Carolina as its flag after secession, it may be considered as having been informally adopted by the people of the state."), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n111",
      "id": "n111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Interestingly, a sovereignty flag")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("was actually raised over Alumni Hall")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("of Yale University")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("in New Haven, Connecticut")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", by a student from the South who was enrolled in the college. Another student, Charles Lee Foster")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", reported the incident to")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Frank Leslie’s Illustrated Newspaper")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", which published an illustration of the flag flying over Alumni Hall on the same day that the")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Illustrated London")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("News")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("published its illustration.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n112",
      "id": "n112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("No flag was officially adopted by the seceded state of South Carolina")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", though, until January 26, 1861. The flag that was actually adopted was hardly like the sovereignty flag")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". Rather, it was a blue flag with a large white oval in the center. In the white oval was the palmetto tree")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", and in the upper-left corner of the flag was a white crescent. The flag’s authorization lasted two days! On January 28, the State Legislature changed the flag again. This time, the flag it adopted was blue with a white palmetto tree in the center and a white crescent in the upper-left corner, altogether not too dissimilar to the flag of the State of South Carolina today.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n113",
      "id": "n113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("The months of January and February 1861 have been referred to as the great “Secession Winter")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(",” as, one-by-one, the Gulf states")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("seceded from the Union. Mississippi seceded from the Union on January 9, Florida on January 10, Alabama on January 11, Georgia on January 19, Louisiana on January 26, and Texas on February 1. Within a space of forty-two days, seven states, from South Carolina")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("to Texas, had seceded from the Union.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n114",
      "id": "n114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("During the height of the secession")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("of the Gulf states")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", a profusion of secession flags appeared. The flag that hung at the secession convention")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("in Alabama had a blue field lined with gold fringe; in the center of the flag was the figure of “Liberty,” dressed in red, holding a flag in her left hand and a sword in her right. Over Liberty were the words: “")]), _c('span', {
    staticClass: "char-style-override-11"
  }, [_vm._v("independent now and forever")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(".”")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n115",
      "id": "n115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "frame-2a"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "9%20Georgia%20Secession_upsized.tif",
      "src": "Images/9%20Georgia%20Secession_up_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame-10"
  }, [_c('p', {
    staticClass: "caption-8",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("A secession rally in Savannah Georgia, a woodcut. "), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("(Courtesy of the Library of Congress)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Many of those early flags bore a strong resemblance to the Stars and Stripes")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". When Louisiana seceded from the Union on January 26, 1861, a flag appeared bearing six five-pointed, white stars in a blue field representing the seceded states of South Carolina")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", Florida, Georgia, Alabama, Mississippi, and Louisiana; thirteen alternating red and white stripes completed the flag. That secession")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("flag")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("was a copy of the Stars and Stripes; it illustrated the attachment many Southerners had to the old Union. The seceded states of Florida and Louisiana would adopt flags that were similar to the Stars and Stripes. In spite of their urge to leave the Union, many Southerners embraced the history they had in common with the United States and consciously sought to model their emblems to resemble those of the old Union.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n116",
      "id": "n116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("On February 1, 1861 the delegates from the six Southern states that had proclaimed their independence from the United States met in the capitol")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("building in Montgomery, Alabama")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("to form a new confederacy")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". The popular sentiment there—but not necessarily elsewhere in the Confederacy—was that the main features of the old United States Constitution")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("should be incorporated into the Confederate Constitution")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("and that, to give expression to that fact, the flag of the Confederacy should closely resemble that of the Stars and Stripes")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(".")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n117",
      "id": "n117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("The capitol building where the delegates hammered out a constitution and set about forming a new government was an imposing building. Built on a hill overlooking the city of Montgomery, Alabama")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", the capitol building faced the main thoroughfare of the city, Market Street. The three-story, neoclassical structure was made of plastered brick, scored to resemble stone. Its dome was rust colored and across the front was a three-story-high portico supported by six Corinthianesque columns. Atop the portico was an immense clock. The unkempt capitol")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("grounds were defined by an iron fence that was missing sections. The capitol building faced Market Street; one half mile away was Court Square, the business district, where there was a large artesian well enclosed by an iron fence.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n118",
      "id": "n118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("It was on the second-floor veranda of the capitol")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("building, framed by the giant columns, that Jefferson Davis")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("was sworn in as president of the Confederacy")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("on February 18, 1861. Illustrating the fact that the Confederacy had no unique, identifying flag, over the capitol building flew the flag of the State of Alabama, and Davis’s inaugural procession was led by a company of infantry carrying the flag of the State of Georgia. The old capitol building in Montgomery would serve as the Confederate Capitol")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("until the seat of government was moved to Richmond, Virginia, at the end of May 1861, a move that began, in essence, with a resolution offered by Francis S. Bartow")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("of Georgia on May 11.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n119",
      "id": "n119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("On February 9, 1861, Christopher Memminger")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", a delegate from South Carolina")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", brought to the attention of the Provisional Congress")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("in the capitol at Montgomery two different flag designs, one of which he called a “sovereignty flag.")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("” Made by the young ladies of Charleston")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", this flag was “much admired.” That proposal resembled the Latin cross")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("design so popular in South Carolina. It had a red field with a blue cross “studded with seven white stars,” just like the original sovereignty flag. Another was a design that consisted of a blue cross with fifteen stars on a field of red and white stripes. Submitting the proposals, Memminger")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("stated:")])]), _vm._v(" "), _c('p', {
    staticClass: "x-e-Extract-6 para-style-override-14"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "frame-2"
  }, [_c('img', {
    staticClass: "frame-1a",
    attrs: {
      "alt": "11%20Inaug%20of%20Jefferson%20Davis.jpg",
      "src": "Images/11%20Inaug%20of%20Jefferson%20_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame-10"
  }, [_c('p', {
    staticClass: "caption-8",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The inauguration of Jefferson Davis as president of the Confederacy, February 18, 1861, at the State Capitol, Montgomery, Alabama. "), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("(Courtesy of the Alabama Department of Archives and History, Montgomery, Alabama)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "x-e-Extract-6 para-style-override-14"
  }), _vm._v(" "), _c('p', {
    staticClass: "x-e-Extract-6 para-style-override-14"
  }, [_vm._v("Mr. President, the idea of a union, no doubt was suggested to the imagination of the young ladies by the beauteous constellation of the Southern Cross, which the great Creator has placed in the southern heavens, by way of compensation for the glorious constellation at the north pole. The imagination of the young ladies was, no doubt, inspired by the genius of Dante and the scientific skill of Humbolt. But, sir, I have no doubt that there was another idea associated with it in the minds of the young ladies—a religious one—and although we have not seen in the heavens the “in hoc signo vinces,” written upon laburnum of Constantine, yet the same sign has been manifested to us upon the tablets of the earth; for we all know that it has been by the aid of revealed religion that we have achieved over the fanaticism the victory which we this day witness; and it is beckoning, on this occasion, that the debt of the South to the cross should be thus recognized.")]), _vm._v(" "), _c('p', {
    staticClass: "x-e-Extract-6 para-style-override-15"
  }, [_vm._v("I have also, Mr. President, a commission from a gentleman of taste and skill in the city of Charleston, who offers another model, which embraces the same idea of a cross, but upon a different ground. The gentleman who offers this model appears more hopeful than the young ladies. They offer one with seven stars—six of the States already represented in the Congress, and the seventh for Texas, whose deputies we hope will soon be on their way to join us. He offers a flag which embraces the whole fifteen States. God grant that this hope may soon be realized, and that we may soon welcome their stars to the glorious constellation of the Southern Confederacy."), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n120",
      "id": "n120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Another proposal submitted to the Provisional Congress")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("included a blue Latin cross")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("containing white stars with a red field not too dissimilar from the sovereignty flag")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". Wrote the")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Charleston Daily Courier")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("on February 15, 1861:")])]), _vm._v(" "), _c('p', {
    staticClass: "x-e-Extract-6 para-style-override-16"
  }, [_vm._v("The “Southern Cross” is a favorite with many citizens whose opinions have reached us, and has been presented in a variety of forms, by a gentleman of this city, who proposed it, we believe, soon after, if not before, the secession of South Carolina."), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n121",
      "id": "n121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("The flag that emerged in Congress was designed by Nichola Marschall")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("of Marion, Alabama. Marschall")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("was born in St. Wendel, Germany, in 1829. His family were well-to-do tobacco merchants. He immigrated to the United States in 1849 through New Orleans and took up residence in the home of a relative in Mobile, Alabama. In 1851 Marschall")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("relocated to Marion, where he began teaching art at his own studio and at the Marion Female Seminary")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". He also painted portraits commercially. Marschall")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("briefly returned to Germany to continue his own training but journeyed back to Marion before the outbreak of the Civil War")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(".")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n122",
      "id": "n122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Marschall")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("’s flag consisted of two horizontal red stripes and a center white stripe with a blue field containing a circle of white, five-pointed stars representing the Confederate states. It became known far and wide as the “Stars and Bars")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(",” for it bore a strong resemblance to the Stars and Stripes")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". On March 4, 1861, the Stars and Bars flag was adopted by the Provisional Confederate Congress")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". It was raised over the capitol")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("building by Miss Letitia Christian Tyler")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", the granddaughter of Pres. John Tyler")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", that same day.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n123",
      "id": "n123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("The Stars and Bars")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("was met with mixed reviews in the Confederacy")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". The")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Charleston")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Mercury")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("reported the first appearance of the new flag:")])]), _vm._v(" "), _c('p', {
    staticClass: "x-e-Extract-6"
  }, [_c('span', [_vm._v("The National Ensign of the Confederate States of America was displayed yesterday from the flagstaff over the cupola of the Customs House")]), _vm._v(" "), _c('span', [_vm._v("[in Charleston")]), _c('span', [_vm._v("]. It attracted a great deal of attention, and various opinions were expressed concerning it. Some thought it too much like the United States flag—others had set their hearts upon the ‘Southern Cross")]), _c('span', [_vm._v("’ being somehow embodied in our new banner.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n124",
      "id": "n124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("When Maj. Robert H. Anderson")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("surrendered his Federal garrison at Fort Sumter")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("to Gen. Pierre Gustave Toutant Beauregard")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("on April 13, 1861, the Confederate forces took over the fort at the mouth of Charleston Harbor")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". Before anything further was done in the captured fort, the jubilant Confederates raised an immense Stars and Bars")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("flag along with the palmetto flag of South Carolina")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". The Stars and Bars and the South Carolina palmetto flag fluttered over the bastion of the new Confederacy")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(".")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n125",
      "id": "n125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("One member of the Provisional Confederate Congress")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("who objected to the Stars and Bars")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("was William Porcher Miles")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("of South Carolina")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", the chairman of the House Military Committee")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". Miles")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", born on July 4, 1832, was the son of a plantation family from Walterboro in the Colleton District of South Carolina. He was graduated from the College of Charleston")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("in 1842. Although admitted to the bar, Miles")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("chose a career teaching mathematics at his alma mater, where he served as an assistant professor from 1843 until 1855. He became mayor of Charleston in 1855 and then was elected to Congress in 1857. Miles")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("served in Congress until South Carolina seceded from the Union in December 1860; he then served as a delegate to the South Carolina Secession Convention")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("and was elected to the Provisional Confederate Congress as well as the First and Second Congresses of the permanent Confederate government. In 1863, Miles")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("would marry the former Elizabeth Bevine")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", the daughter of a Virginia planter with large land holdings in the Old Dominion as well as Louisiana.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n126",
      "id": "n126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "frame-2a"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "14%20Flag%20at%20Sumter_upsized.tif",
      "src": "Images/14%20Flag%20at%20Sumter_upsi_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame-10"
  }, [_c('p', {
    staticClass: "caption-8",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Fort Sumter after the surrender of the Federal garrison on April 13, 1861, showing the Stars and Bars flying over the damaged fort. "), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("(Courtesy of the Library of Congress)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Miles")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("regarded the United States flag as the emblem of a tyrannical government. He preferred a red flag bearing a blue heraldic emblem—the saltire,")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("or St. Andrew’s Cross—with inner rows of stars. “The saltire,” reported the")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Charleston")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("Mercury")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", echoing Miles")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("’ contentions, “is the symbol of strength,” and the stars, which in Miles")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("’ original drawings were six-pointed stars known as")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("é")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("toiles, represented the Confederate states. The House Military Committee")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", however, flatly rejected Miles")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("’ effort to change the Confederate flag.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n127",
      "id": "n127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('div', {
    staticClass: "frame-2a"
  }, [_c('img', {
    staticClass: "frame-1a",
    attrs: {
      "alt": "48%20Colonel%20Walton_upsized.tif",
      "src": "Images/48%20Colonel%20Walton_upsi_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame-10"
  }, [_c('p', {
    staticClass: "caption-8",
    staticStyle: {
      "text-align": "center",
      "width": "95%"
    }
  }, [_vm._v("Col. James Burdge Walton, commander of the Washington Artillery Battalion of New Orleans, a carte-de-visite photograph. "), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("(Courtesy of the Alabama Department of Archives and History, Montgomery, Alabama)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("The saltire")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("was, in fact, the oldest emblem of sovereignty in the Western world, having its origins with the Scotts maybe as early as AD 832. It was used by the Romans in Britain as a boundary emblem years before then. The word")]), _vm._v(" "), _c('span', {
    staticClass: "italics char-style-override-6"
  }, [_vm._v("saltire")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("is derived from the Latin “salto,” meaning “to leap” or “to jump,” and it was applied to the boundary emblems as the Roman Empire’s expansion into Britain and elsewhere was recorded by the placement of those emblems along the empire’s ever-widening frontier.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n128",
      "id": "n128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-17"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("The saltire")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("of Miles")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("’ design")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("was also known as the St. Andrew’s Cross")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", named in honor of the first-century Christian martyr")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("who was crucified on a saltire. It was said St. Andrew’s")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("remains were sent to the Scottish coast in the fourth century. St. Andrew")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("became the patron saint of Scotland; his cross became the nation’s symbol. The St. Andrew’s Cross")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("was incorporated into the British Union Jack when King James")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("VI of Scotland became King James I of England.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n129",
      "id": "n129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-17"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("In April 1861 Col. James Burdge Walton")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", commander")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("of the famed battalion of the Washington Artillery")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("of New Orleans, requested newspaperman Edward C. Hancock")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("of New Orleans to draw a proposed group of flags for Confederate military purposes. Hancock")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("’s proposal consisted of a color rendition of a flag with a rectangular field of red. It apparently resembled the sovereignty flag")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", having a red field and a dark blue Latin cross with white stars quartering the field horizontally and vertically.")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n130",
      "id": "n130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Although Hancock")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("completed his drawings, they were never sent to the House Military Committee")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("of the Provisional Congress")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("in Montgomery, Alabama")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(". Knowing there was to be a transfer of the seat of government from Montgomery to Richmond, Virginia, Maj. Walton")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("carried Hancock")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("’s drawings with him when the original four companies of the Washington Artillery")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Battalion were transferred to Richmond in May 1861. Walton")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("recalled: “I carried . . . the design to [Richmond], where it was freely exhibited and generally approved. Among others, it was shown to Colonel [William] Porcher Miles")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(", a member of our flag committee.”")]), _c('span', {
    attrs: {
      "href": "#/Text/Notes#n131",
      "id": "n131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("What finally underscored the need for a change, though, was the use of the Stars and Bars")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("—and the widespread use of a multitude state flags—by Confederate regiments on the battlefield.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e5c934f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/SCRPp1.vue
// module id = 78
// module chunks = 0